import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import UserLayout from "../layouts/ClientLayout";

import Dashboard from "../pages/user/Dashboard";
import Templates from "../pages/user/Templates";
import Creatives from "../pages/user/Creatives";
import Campaigns from "../pages/user/Campaigns";
import Profile from "../pages/public/Profile";
import ChangePassword from "../pages/public/ChangePassword";
import Editor from "../pages/user/Editor";
import QRDesigner from "../pages/user/QREditor";
import XMLTester from "../pages/user/XMLTester";
import PermissionRoute from "./PermissionRoute";

export default function UserRoutes() {
  return (
    <Route
      path="/user"
      element={
        <ProtectedRoute
          roles={["user"]}
          redirectTo="/login"         // 🔥 redirect unauthenticated to login
          fallbackRedirect="/user"  // 🔥 if role mismatch, go to dashboard (or /admin)
        >
          <UserLayout />
        </ProtectedRoute>
      }
    >
      <Route
        index
        element={
          <PermissionRoute permission="Dashboard">
            <Dashboard />
          </PermissionRoute>
        }
      />

      <Route
        path="templates"
        element={
          <PermissionRoute permission="Templates">
            <Templates />
          </PermissionRoute>
        }
      />

      <Route
        path="creatives"
        element={
          <PermissionRoute permission="Creatives">
            <Creatives />
          </PermissionRoute>
        }
      />

      <Route
        path="campaigns"
        element={
          <PermissionRoute permission="Campaigns">
            <Campaigns />
          </PermissionRoute>
        }
      />

      <Route
        path="editor"
        element={
          <PermissionRoute permission="Creatives">
            <Editor />
          </PermissionRoute>
        }
      />

      <Route
        path="xml-tester"
        element={
          <XMLTester />
        }
      />

      <Route
        path="qr-generator"
        element={
          <QRDesigner />
        }
      />

      {/* Always accessible */}
      <Route path="profile" element={<Profile />} />
      <Route path="change-password" element={<ChangePassword />} />
    </Route>
  );
}